import { ref } from 'vue'

// Estado global de carga de navegación entre rutas (chunks lazy).
// Se muestra solo si la navegación tarda más que `delay` para evitar
// parpadeos en vistas ya cacheadas que cargan al instante.
const isRouteLoading = ref(false)
let timer = null

function startRouteLoading(delay = 200) {
  clearTimeout(timer)
  timer = setTimeout(() => {
    isRouteLoading.value = true
  }, delay)
}

function stopRouteLoading() {
  clearTimeout(timer)
  timer = null
  isRouteLoading.value = false
}

export function useRouteLoading() {
  return { isRouteLoading, startRouteLoading, stopRouteLoading }
}
